const DocumentTabType = {
    GENERAL: 1,
    PERSONAL: 2,
    DOCUMENT_EXCHANGE_APPROVAL: 3
}
export default DocumentTabType